import FormControls from 'component/FormControls';
import Page from 'component/Page';
import { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { Button, Form, Row } from 'react-bootstrap';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  focusElement,
  getFormData,
  showConfirm,
  showToast,
  nNU,
  serialValidate,
  couponCodeValidate,
  formatDate,
} from 'util/utils';

const modelTable = [
  'DRDPM62W',
  'EMS938W',
  "DJDPS72W",
  'EME90WNC',
];

const modelPrepaidTable = [
//  'DRDPM62W',
//  'EMS938W',
  "DJDPS72W",
  'EME90WNC',
];

const PocUserCoupon = ({ data = { pocId: null, valid: true }, onUpdated }) => {

  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  //const [showPassword, setShowPassword] = useState(false);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [ currentUser.accountRole ]
  );
	const [devices, setDevices]	= useState([]);
	const [prepaidDevices, setPrepaidDevices] = useState([]);
	const [subscribeDevices, setSubscribeDevices] = useState([]);
	const [total, setTotal] = useState(0);

  //------------------------FUNCTIONS----------------------------------------------------------
	// Get device list
	useEffect(() =>{
		async function getDevices() {
			const data = {
				offset: 0,
				size: 100,
			};
			await sendPost({
				url: Urls.servicecode.device,
				body: {
					...data,
				},
			}).then((res) => {
				// console.log(res);
				const {total, result} = res;
				if(total > 0){
					//const cardsList = result.sort((a,b) => parseFloat(b.default_flag) - parseFloat(a.default_flag));
					const devicesList = result.sort((a,b) => a.modelName.localeCompare(b.modelName));
					setTotal(total);
					setDevices(devicesList);
					let prepaid = [];
					let subscribe = [];
					for(let i = 0; i<result.length;i++){
						if (result[i].volume > 0) {
							prepaid = [...prepaid, result[i]]
						} else {
							subscribe = [...subscribe, result[i]]
						}
					}
					setPrepaidDevices(prepaid);
					setSubscribeDevices(subscribe);
				}
			});
		}
		getDevices();
	},[currentUser]);

	if(!nNU(data?.pocId)){
		return;
	}
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let formData = getFormData(e.target, {
      rawCol: {
        model: true,
        serial: true,
        code: true,
        code2: true,
        code3: true,
        code4: true,
      },
    });
    if (!formData?.serial) {
      showToast(string.POC_ACCOUNT_COUPON_SERIAL_EMPTY_ERROR);
      focusElement('#serial');
      return;
    }
    if (!serialValidate(formData?.serial)) {
      showToast(string.POC_ACCOUNT_COUPON_SERIAL_FORMAT_ERROR);
      focusElement('#serial');
      return;
    }
    if (!formData?.code) {
      showToast(string.POC_ACCOUNT_COUPON_CODE1_EMPTY_ERROR);
      focusElement('#code');
      return;
    }
    if (!formData?.code2) {
      showToast(string.POC_ACCOUNT_COUPON_CODE2_EMPTY_ERROR);
      focusElement('#code2');
      return;
    }
    if (!formData?.code3) {
      showToast(string.POC_ACCOUNT_COUPON_CODE3_EMPTY_ERROR);
      focusElement('#code3');
      return;
    }
    if (!formData?.code4) {
      showToast(string.POC_ACCOUNT_COUPON_CODE4_EMPTY_ERROR);
      focusElement('#code4');
      return;
    }
    if (
      !couponCodeValidate(formData?.code) ||
      !couponCodeValidate(formData?.code2) ||
      !couponCodeValidate(formData?.code3) ||
      !couponCodeValidate(formData?.code4)
    ) {
      showToast(string.POC_ACCOUNT_COUPON_CODE_FORMAT_ERROR);
      focusElement('#code');
      return;
    }

    let couponData = {
      pocId: data?.pocId,
      modelName: formData?.model,
      serialNumber: formData?.serial.toUpperCase(),
      couponCode: `${formData?.code.toUpperCase()}${formData?.code2.toUpperCase()}${formData?.code3.toUpperCase()}${formData?.code4.toUpperCase()}`,
      // type: (data?.status === 1) ? 1 : (formData?.model === modelTable[ 0 ]) ? 0 : 1,
			type: getCouponPlanType(formData?.model),
    };
    showConfirm({
      body: string.POC_ACCOUNT_COUPON_CODE_APPLY_CONFIRM,
      defaultAction: () => {
        sendPost({
          url: Urls.pocaccount.coupon,
          body: couponData,
        })
          .then((res) => {
            const { status } = res;
            const result = !!nNU(res?.result) ? res?.result : '';
            const errorCode = !!nNU(res?.errorCode) ? res?.errorCode : null;
            if (status === 'SUCCESS') {
              if (errorCode === null) {
                showToast(
                  string.POC_ACCOUNT_COUPON_CODE_APPLY_SUCCESS,
                  'success'
                );
              } else {
                if (!!nNU(result?.remaining) && result?.remaining > 0) {
                  showToast(
                    `${string.POC_ACCOUNT_COUPON_CODE_APPLY_ERROR
                    }\n残り入力回数：${!!nNU(result?.remaining) ? result?.remaining : '0'
                    }回です。`,
                    'warning'
                  );
                } else {
                  showToast(
                    `${string.POC_ACCOUNT_COUPON_CODE_REPEAT_ERROR}\n${!!nNU(result?.tryAgainAt)
                      ? `${formatDate(
                        result.tryAgainAt,
                        'YYYY年MM月DD日 HH時以降'
                      )}${string.POC_ACCOUNT_COUPON_REAPPLY}`
                      : ''
                    }`,
                    'error'
                  );
                }
              }
            }
            onUpdated(res);
          })
          .catch((e) => { });
      },
    });
  };
  const onSerialChanged = (e) => {
    const serial = e.target.value.toUpperCase();
    e.target.value = serial;
    if (serial.length > 6) {
      focusElement('#code');
    }
  };
  const onCode1Changed = (e) => {
    // console.log('onCode1Changed' + e.target.value);
    const code = e.target.value.toUpperCase();
    e.target.value = code;
    if (code.length > 3) {
      focusElement('#code2');
    }
  };
  const onCode2Changed = (e) => {
    // console.log('onCode2Changed');
    const code = e.target.value.toUpperCase();
    e.target.value = code;
    if (code.length > 3) {
      focusElement('#code3');
    }
  };
  const onCode3Changed = (e) => {
    // console.log('onCode3Changed');
    const code = e.target.value.toUpperCase();
    e.target.value = code;
    if (code.length > 3) {
      focusElement('#code4');
    }
  };
  const onCode4Changed = (e) => {
    // console.log('onCode4Changed');
    const code = e.target.value.toUpperCase();
    e.target.value = code;
    if (code.length > 3) {
      // focusElement('#submit');
    }
  };
	const getCouponPlanType = (modelName = null) => {
		if(modelName === null) {
			return 0;
		}
		let type = 0;
		for(let i = 0;i < prepaidDevices.length;i++) {
			if(modelName === prepaidDevices[i].modelName){
				type = 1;
				break;
			}
		}
		return type;
	};

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <Page
        title={`${data?.username}の${string.POC_ACCOUNT_COUPON_TITLE}${string.POC_ACCOUNT_COUPON}`}
        body={
          <>
            <Form onSubmit={onSubmit}>
              {/* <Card.Title>{string.APP_ACCOUNT_SETTING}</Card.Title> */}
              <FormControls
                data={data}
                controls={[
                  {
                    id: 'model',
                    title: string.POC_ACCOUNT_COUPON_MODEL,
                    type: 'selection',
                    options: data?.planType === 1 ? prepaidDevices.map((device) => ({ select: device.modelName })) : devices.map((device) => ({ select: device.modelName })),
                    // options: data?.planType === 1 ? modelPrepaidTable.map((value) => ({ select: value })) : modelTable.map((value) => ({ select: value })),
                  },
                  {
                    id: 'serial',
                    title: string.POC_ACCOUNT_COUPON_SERIAL,
                    maxlength: '7',
                    onChange: onSerialChanged,
                  },
                  {
                    id: 'code',
                    title: string.POC_ACCOUNT_COUPON_CODE1,
                    maxlength: '4',
                    onChange: onCode1Changed,
                  },
                  {
                    id: 'code2',
                    title: string.POC_ACCOUNT_COUPON_CODE2,
                    maxlength: '4',
                    onChange: onCode2Changed,
                  },
                  {
                    id: 'code3',
                    title: string.POC_ACCOUNT_COUPON_CODE3,
                    maxlength: '4',
                    onChange: onCode3Changed,
                  },
                  {
                    id: 'code4',
                    title: string.POC_ACCOUNT_COUPON_CODE4,
                    maxlength: '4',
                    onChange: onCode4Changed,
                  },
                ]}
                footer={<></>}
              />
              {/* <Card.Title>{string.APP_PASSWORD_CHANGE}</Card.Title> */}
              <Row className="form-button-row" id="submit">
                <Button type="submit">
                  {string.POC_ACCOUNT_COUPON_SUBMIT}
                </Button>
              </Row>
            </Form>
          </>
        }
      />
    </>
  );
};

export default PocUserCoupon;
